import { HStack, Text, VStack } from '@chakra-ui/react';

import { EAgentExecutionStatus } from '@/types/agents';

import StandardBadge from '../StandardBadge/StandardBadge';
import StatusBadge from '../StatusBadge/StatusBadge';
import StatusIcon from '../StatusIcon/StatusIcon';

export type LogItemProps = {
  title: string;
  time: string;
  status?: EAgentExecutionStatus;
  duration?: string;
  error?: string;
  errorCode?: number;
};

const LogItem = ({ item }: { item: LogItemProps }) => {
  const showStatus = item.status && item.status !== EAgentExecutionStatus.IN_PROGRESS;
  const showDuration =
    item.duration &&
    item.status !== EAgentExecutionStatus.IN_PROGRESS &&
    item.status !== EAgentExecutionStatus.FAILED;
  const showTime = !item.status || item.status !== EAgentExecutionStatus.IN_PROGRESS;
  const errorCode = item.errorCode != null ? `(${item.errorCode}) ` : '';

  return (
    <HStack align="start" gap={4}>
      <StatusIcon status={item.status} />
      <VStack w="100%" align="flex-start" gap={3}>
        <HStack justify="space-between" w="100%" align="start" mt={1}>
          <Text fontWeight="medium">{item.title}</Text>
          {showTime && (
            <Text fontSize="xs" color="gray.500">
              {item.time}
            </Text>
          )}
        </HStack>
        {showStatus && (
          <HStack gap={3} w="100%">
            <Text fontSize="14px" color="text.fg" minWidth="22%">Status:</Text>
            <StatusBadge status={item.status}/>
          </HStack>
        )}
        {showDuration && (
          <HStack gap={3} w="100%">
            <Text fontSize="14px" color="text.fg" minWidth="22%">Duration:</Text>
            <StandardBadge variant="subtle">{item.duration}</StandardBadge>
          </HStack>
        )}
        {item.error && (
          <HStack gap={3} w="100%">
            <Text fontSize="14px" color="text.fg" minWidth="22%">Error:</Text>
            <StandardBadge variant="subtle">
              {errorCode}
              {item.error}
            </StandardBadge>
          </HStack>
        )}
      </VStack>
    </HStack>
  );
};

export default LogItem;